import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface DocumentPreviewDialogData {
  filePath: string;
  fileName: string;
}

@Component({
  selector: 'app-document-preview-dialog',
  templateUrl: './document-preview-dialog.component.html',
  styleUrls: ['./document-preview-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocumentPreviewDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) readonly data: DocumentPreviewDialogData,
    private readonly dialogRef: MatDialogRef<DocumentPreviewDialogComponent>
  ) {}

  close(): void {
    this.dialogRef.close();
  }
}
